import { render, staticRenderFns } from "./trendView.vue?vue&type=template&id=24aba9a1&scoped=true"
import script from "./trendView.vue?vue&type=script&lang=js"
export * from "./trendView.vue?vue&type=script&lang=js"
import style0 from "./trendView.vue?vue&type=style&index=0&id=24aba9a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aba9a1",
  null
  
)

export default component.exports